import { Component, Input, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';

import { CommonModule } from '@angular/common';
import { GovBrLoadingModule } from '@serpro/ngx-dsgovbr';
import { LoadingService } from '../../services/loading.service';


@Component({
  selector: 'my-loading',
  templateUrl: './my-loading.component.html',
  styleUrl: './my-loading.component.scss',
  standalone: true,
  imports: [
    CommonModule, GovBrLoadingModule
  ]
})
export class MyLoadingComponent implements OnInit {

  loading$: Observable<boolean>;

  @Input()
  detectRouteTransitions = false;

  constructor(
    private loadingService: LoadingService,
    private router: Router
  ) {
    this.loading$ = this.loadingService.loading$;
  }

  ngOnInit() {
    if (this.detectRouteTransitions) {
      this.router.events
        .pipe(
          tap((event: any) => {
            if (event instanceof RouteConfigLoadStart) {
              this.loadingService.loadingOn();
            } else if (event instanceof RouteConfigLoadEnd) {
              this.loadingService.loadingOff();
            }
          })
        )
        .subscribe();
    }
  }

}
